import React, { Component } from 'react';
import { connect } from 'react-redux';

import { setAuthAction } from "../actions";
import { Container } from "./Container";
import { companyAtividadesModel } from "../models";

import { TextInput, Button, SelectInput } from "../atoms";
import { LocationInput, PasswordInput } from "../molecules";
import { handleChangeInputText, handleChangeInputLocation } from "../helpers";
import { SignupController } from "../controllers";

class Signup extends Container {

	constructor(props) {
		super(props);
		this.state = {
			values: {
				values: {
					address: {}
				},
				address: { },
				password: "",
				confirmPassword: "",
				email: "",
				atividade: "",
				cnpj: "",
			},
			errors: {
				values: {
					address: {}
				},
				address: {},
				password: "",
				confirmPassword: "",
				email: "",
				atividade: "",
				cnpj: "",
			}
		};

		this.controller = new SignupController(this);
		this.change = this.change.bind(this);
	}

	componentWillMount(){
		// this.controller.fetchUser();
	}

	change(values, id, targetId){
		const state = this.getState();
		state.values[targetId] = values[id][targetId];
		this.callback(state);
	}

	render() {
		return( 
			<section className="signup flex -v -c -al-c">
				<div className="header flex -h -c -al-c">
					<h1 className="title">Cadastrar-se</h1>
				</div>			
				<form action={e => {e.preventDefault(); this.controller.createUser(e);}} className="flex -v -c -al-c signup-form">
					<TextInput	
						id="nameCompany" 
						label="Nome da Empresa"
						error={this.state.errors.nameCompany}
						changeAction={e => handleChangeInputText(e, "values", this.change, this.state.values)}
						/>
					<TextInput	
						id="cnpj" 
						label="CNPJ da Empresa"
						error={this.state.errors.cnpj}
						changeAction={e => handleChangeInputText(e, "values", this.change, this.state.values)}
						/>
					<SelectInput	
						id="atividade" 
						label="Segmento de atividade"
						className="text-input"
						error={this.state.errors.atividade}
						options={companyAtividadesModel}
						value={this.state.values.atividade}
						changeAction={e => handleChangeInputText(e, "values", this.change, this.state.values)}
						/>
					<TextInput	
						id="site" 
						label="Site"
						changeAction={e => handleChangeInputText(e, "values", this.change, this.state.values)}
						/>
					<TextInput	
						id="quantStaff" 
						label="Número de colaboradores"
						changeAction={e => handleChangeInputText(e, "values", this.change, this.state.values)}
						/>
					<TextInput	
						id="nameUser" 
						label="Nome do responsável pelo preenchimento dos dados"
						error={this.state.errors.nameUser}
						changeAction={e => handleChangeInputText(e, "values", this.change, this.state.values)}
						/>
					<TextInput	
						id="role" 	
						label="Cargo"
						error={this.state.errors.role}
						changeAction={e => handleChangeInputText(e, "values", this.change, this.state.values)}
						/>
					<TextInput	
						id="email" 	
						label="E-mail"
						type="email"
						error={this.state.errors.email}
						changeAction={e => handleChangeInputText(e, "values", this.change, this.state.values)}
						/>
					<div className="password-inputs">
						<PasswordInput	
							id="password" 	
							label="Senha"
							error={this.state.errors.password}
							handleChange={e => handleChangeInputText(e, "values", this.change, this.state.values)}
						/>
						<PasswordInput	
							id="confirmPassword" 	
							label="Confirmar senha"
							handleChange={e => handleChangeInputText(e, "values", this.change, this.state.values)}
						/>
					</div>
					<LocationInput 
						handleChange={(e) => handleChangeInputLocation(e, "address", this.change, this.state.values)} 
						name="address"
						label="Endereço"
						isRegistration="true"
						values={this.state.values.address}
					/>
					<Button className="submit-button" clickAction={this.controller.createUser} >ENVIAR</Button>
				</form>
			</section>
		);
	}
}

const map = state => {
	return {

	};
};

export default connect(map, {setAuthAction})(Signup);


// WEBPACK FOOTER //
// src/containers/Signup.js